import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "../../../../../../redux/store";
import type { UpdateRolesBody } from "@shared-kernel/application/ports/admin/admin-repository";

export interface UpdateRolesParams {
  userId: string;
  body: UpdateRolesBody;
}

export const updateRoles = createAsyncThunk<string, UpdateRolesParams, { extra: Partial<Dependencies> }>(
  "admin/users/updateRoles",
  async ({ userId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateRoles(userId, body);
    return userId;
  },
);

export const resetUpdateRoles = createAction("admin/users/resetUpdateRoles");
